import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FeriadoRoutingModule} from './feriado-routing.module';
import {FeriadoComponent} from './feriado.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {CadastrarFeriadoComponent} from "./cadastrar-feriado/cadastrar-feriado.component";

@NgModule({
    declarations: [FeriadoComponent, CadastrarFeriadoComponent],
    imports: [
        CommonModule,
        FeriadoRoutingModule,
        MaterialCommonModule
    ]
})
export class FeriadoModule {
}
